import runtimeEnv from '@mars/heroku-js-runtime-env';
const env = runtimeEnv();

let REACT_APP_SITE_KEY = '#wexUc+qk`7YqRy=';
// let REACT_APP_SITE_KEY = "ey7feisufefuhifus";
let REACT_APP_RESOURCE_URL = 'https://dev.mercurycart.ca/';
let REACT_APP_API_URL = 'https://dev.mercurycart.ca/api/';

let REACT_APP_STRIPE_KEY = 'pk_test_sTJOfP0Ose3I7iCMZ3wYfxMf00N3G2t4x6';
// let REACT_APP_STRIPE_KEY = "pk_test_PDzQFir3QmKJokgaZszdfOU9";

let REACT_APP_RECAPTCHA_KEY = '6LdD7GcUAAAAAC9AwCnuA7mpAqLTu7d_GsOhWdQg';

// We need to check if we are serving on the server or client/browser
// If on the client, we have what we need.
// If on the server, then we need to use the dotenv package
let finalEnv = {};
if (!env.REACT_APP_SITE_KEY) {
    require('dotenv').config();
    finalEnv = process.env;
} else {
    finalEnv = env;
}

if (process.env.NODE_ENV === 'production') {
    REACT_APP_SITE_KEY = finalEnv.REACT_APP_SITE_KEY;
    REACT_APP_RESOURCE_URL = finalEnv.REACT_APP_RESOURCE_URL;
    REACT_APP_API_URL = finalEnv.REACT_APP_API_URL;
    REACT_APP_STRIPE_KEY = finalEnv.REACT_APP_STRIPE_KEY;
    REACT_APP_RECAPTCHA_KEY = finalEnv.REACT_APP_RECAPTCHA_KEY;
}

// console.log('vars: ', finalEnv.REACT_APP_API_URL)

export {
    REACT_APP_SITE_KEY,
    REACT_APP_RESOURCE_URL,
    REACT_APP_API_URL,
    REACT_APP_STRIPE_KEY,
    REACT_APP_RECAPTCHA_KEY,
};



// WEBPACK FOOTER //
// ./src/shared/vars.js